import { useTranslation } from '@web_opxp/features';
import { SKELETON_CLASSNAME } from '../base/constants';
import './TabSwitch.scss';

export interface ITabSwitchProps<T extends string | number | null> {
  tabs: T[];
  titlePrefix: string;
  active: T;
  onClick: (tab: T) => void;
}

/**
 *  Generic type for Tab Switch must be an enum type
 **/
export default function TabSwitch<T extends string | number | null>({
  tabs,
  titlePrefix,
  active,
  onClick,
}: Readonly<ITabSwitchProps<T>>) {
  const { t } = useTranslation();
  const loaded = active !== null && active !== undefined;
  const skeletonClass = !loaded ? SKELETON_CLASSNAME : '';
  return (
    <div className="tab-switch" data-testid="tab-switcher">
      {tabs.map((tab) => {
        const domainTitle = t(`${titlePrefix}.${tab}`);
        const activeClass = active === tab ? 'active' : '';
        return (
          <button
            className={`tab-switch-item ${activeClass} ${skeletonClass}`}
            onClick={() => onClick(tab)}
            key={`tab-switch${tab}`}>
            {domainTitle}
          </button>
        );
      })}
    </div>
  );
}
